import React from 'react';
import {MasterLayout} from 'components/layouts';
import {DetailDemand} from 'components/demand';
import title from 'constants/TitlePages.js';

class DetailDemandPage extends React.Component {

  componentDidMount() {
    document.title = title.MyDemandDetailPage;
  }

  render() {
    return (
      <MasterLayout>
        <DetailDemand/>
      </MasterLayout>
    );
  }
}

export default DetailDemandPage;



// WEBPACK FOOTER //
// ./pages/demand/DetailDemandPage.jsx